oyc.MainMenu = {
  menuItems: $('.main-menu .main-menu__item'),
  menuToggleButton: $('.js-menu-toggle'),
  languageMenuToggleButton: $('.js-language-menu-toggle'),
  activeMenuIndex: -1,
  html: $('html'),
  body: $('body'),
  htmlBody: $('html, body'),
  wrapper: $('.page-wrapper'),
  menuNav: $('#site-header nav'),

  init: function () {
    this.isMobile = window.innerWidth < 1024;
    this.bindMenuEvents(this.isMobile);
    this.menuToggleButton.on('click', this.toggleMobileMenu.bind(this));
    this.languageMenuToggleButton.on('click', this.toggleLanguageMobileMenu.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));

    this.setMenuLinksTabindex(-1);
  },

  setMenuLinksTabindex: function (value) {
    this.menuNav.find('a').attr('tabindex', value);
  },

  bindMenuEvents: function (isMobile) {
    this.menuItems.find('button.btn').off('click');
    this.menuItems.find('.main-menu__sub').off('click');
    this.body.off('click');

    if (isMobile) {
      this.menuItems.find('.main-menu__sub').closest('.main-menu__item')
        .find('button.btn').on('click', this.toggleMenu.bind(this));
      this.menuItems.find('.main-menu__sub').on('click', (event) => event.stopPropagation());

      this.body.on('click', this.handleBodyClick.bind(this));
    } else {
      const topBarHeight = $('.top-bar').outerHeight() || 0;
      window.addEventListener('scroll', () => {
        const scrollOffset = Math.min(window.scrollY, topBarHeight);
        $('#site-header nav').css('margin-top', -scrollOffset + 'px');
      });

      this.closeMenu(this.menuItems.eq(this.activeMenuIndex));
    }
  },

  handleResize: function () {
    const isNowMobile = window.innerWidth < 1024;
    if (isNowMobile !== this.isMobile) {
      this.isMobile = isNowMobile;
      this.bindMenuEvents(this.isMobile);
    }
  },

  toggleMenu: function (event) {
    const $item = $(event.currentTarget).closest('.main-menu__item');
    const index = $item.index();

    if (this.activeMenuIndex === index) {
      this.closeMenu($item);
    } else {
      if (this.activeMenuIndex !== -1) {
        this.closeMenu(this.menuItems.eq(this.activeMenuIndex));
      }
      this.openMenu($item, index);
    }

    return false;
  },

  openMenu: function ($item, index) {
    $item.addClass('open');
    this.activeMenuIndex = index;
    $item.find('.js-submenu-close').off('click').on('click', (e) => {
      this.closeMenu($item);
    });
  },

  closeMenu: function ($item) {
    $item.removeClass('open');
    this.activeMenuIndex = -1;
  },

  handleBodyClick: function (event) {
    if (this.activeMenuIndex !== -1 && !$(event.target).closest('.main-menu__item').length) {
      this.closeMenu(this.menuItems.eq(this.activeMenuIndex));
    }
  },

  lockBody: function () {
    this.scrollTop = window.pageYOffset || 0;
    this.wrapper.css({top: -this.scrollTop});
    this.htmlBody.addClass('no-scroll');
  },

  unlockBody: function () {
    this.htmlBody.removeClass('no-scroll');
    this.wrapper.css({top: ''});
    window.scrollTo(0, this.scrollTop || 0);
    this.scrollTop = null;
  },

  toggleMobileMenu: function () {
    if (this.html.hasClass('language-menu-opened')) {
      this.html.removeClass('language-menu-opened');
      this.languageMenuToggleButton.attr('aria-expanded', 'false');
    }

    const isMenuOpen = this.html.toggleClass('menu-opened').hasClass('menu-opened');
    this.menuToggleButton.attr('aria-expanded', isMenuOpen ? 'true' : 'false');
    if (window.innerWidth < 1024) {
      isMenuOpen ? this.lockBody() : this.unlockBody();
      this.menuItems.removeClass('open');
      this.activeMenuIndex = -1;
    }

    this.setMenuLinksTabindex(isMenuOpen ? '' : -1);
  },

  toggleLanguageMobileMenu: function () {
    if (this.html.hasClass('menu-opened')) {
      this.html.removeClass('menu-opened');
      this.menuToggleButton.attr('aria-expanded', 'false');
      if (window.innerWidth < 1024) {
        this.unlockBody();
      }
    }

    const isMenuOpen = this.html.toggleClass('language-menu-opened').hasClass('language-menu-opened');
    this.languageMenuToggleButton.attr('aria-expanded', isMenuOpen ? 'true' : 'false');
  }
}
